// Copyright (c) 2023, Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { Field } from 'redux-form'
import MultiSelectFromState from 'components/Form/common/MultiSelectFromState'

const targetSet= ['radioSettings', 'companies']

const RadioManufacturer = ({ idRoot }) => (
  <Field
    component={MultiSelectFromState}
    id={idRoot}
    label={''}
    name={'radioCompanyId'}
    labelKey={'companyName'}
    targetSet={targetSet}
    valueKey={'companyId'} />
)

RadioManufacturer.propTypes = {
  idRoot: string.isRequired,
}

export default RadioManufacturer
